import { socialApiRequest, socialDashboardApiRequest } from './apiWrapper'

export async function saveContent(content_id, user_id) {
  return socialApiRequest({
    method: 'post',
    url: `/saved_content`,
    data: { content_id },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export async function fetchSavedContent(user_id,
  content_type = ["image", "audio", 'video'],
  limit = 20,
  offset = 0,
  sort_by = "newest_first",
  created_with = []) {
  const normalizedContentType = Array.isArray(content_type)
    ? content_type
    : [content_type]
  return socialApiRequest({
    method: 'post',
    url: `/saved_contents?limit=${limit}&offset=${offset}`,
    data: {
      content_type: normalizedContentType,
      sort_by,
      created_with
    },
  })
}

export async function deleteSavedContent(content_ids, user_id) {
  return socialApiRequest({
    method: 'delete',
    url: `/saved_content`,
    data: { content_ids: Array.isArray(content_ids) ? content_ids : [content_ids] }
  })
}

export async function fetchReportReasons() {
  return socialApiRequest({
    method: 'get',
    url: 'report_reasons/'
  })
}

export async function PostContentReport(
  content_id,
  reason_for_report,
  reason
) {
  return socialApiRequest({
    method: 'post',
    url: `/report/`,
    data: { content_id, reason_for_report, reason }
  })
}

export async function PostUserReport(reported_user_id, reason) {
  return socialApiRequest({
    method: 'post',
    url: `/report_user/`,
    data: { reported_user_id, reason }
  })
}

export async function deleteDiscoverSavedContent(content_ids) {
  return socialApiRequest({
    method: 'delete',
    url: `/saved_content`,
    data: { content_ids }
  })
}

export async function blockUser(blocked_id) {
  return socialApiRequest({
    method: 'post',
    url: `/block/`,
    data: {blocked_id}
  })
}

export async function fetchBlockedUserList() {
  return socialApiRequest({
    method: 'get',
    url: 'blocked-users'
  })
}

export async function unBlockUser(blocked_id) {
  return socialApiRequest({
    method: 'delete',
    url: `/block/`,
    data: {blocked_id}
  })
}